<template>
  <div class="disciplinePunish h100">
    <!-- <h1>This is an disciplinePunish page</h1> -->
    <el-card>
      <el-form ref="searchListRef" :model="searchList" :inline="true">
        <el-form-item label="年份" prop="year">
          <el-date-picker v-model="searchList.year" type="year" value-format="yyyy" placeholder="请选择年份"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search()">搜 索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetSearch()" plain>清 空</el-button>
        </el-form-item>
      </el-form>
      <el-upload v-if="roles.indexOf('Admin')>-1 || roles.indexOf('SIP')>-1" class="uploadClass" ref="uploadRef" :multiple='false'
        action
        :http-request="upload"
        :data= searchList
        :show-file-list='false'
        :before-upload="beforeUpload">
        <el-button type="primary">文件上传</el-button>
        </el-upload>
      <el-table style="margin-top:20px" :data="data" border header-cell-class-name="headerStyle" cell-class-name="cellStyle">
        <el-table-column v-for="(item, index) in columns" :key="index" :prop="item.prop" :label="item.label"></el-table-column>
        <el-table-column label="文件下载">
          <template slot-scope="scope">
            <template>
              <i class="el-icon-download downloadIcon" @click="download(scope.row)"></i>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="" label="附件状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.file!==null?'success':'danger'" disable-transitions>{{scope.row.file!==null?'已上传':'未上传'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="" label="附件上传" v-if="roles.indexOf('Admin')>-1 || roles.indexOf('SIP')>-1">
          <template slot-scope="scope">
            <el-upload ref="uploadRef" :multiple='false'
            action
            :http-request="attachmentUpload"
            :data= {relationId:scope.row.id}
            :show-file-list='false'>
              <i class="el-icon-upload2 downloadIcon"></i>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column prop="" label="附件下载">
          <template slot-scope="scope">
            <i class="el-icon-download downloadIcon" @click="attachmentDownload(scope.row)"></i>
          </template>
        </el-table-column>
        <el-table-column prop="file.createUser" label="附件上传人"></el-table-column>
        <!-- <el-table-column prop="" label="确认状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.comfirmStatus==='Y'?'success':'danger'" disable-transitions>{{scope.row.confirmStatus==='Y'?'已确认':'未确认'}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="roles.indexOf('Admin')>-1 || roles.indexOf('HR')>-1" label="确认">
          <template slot-scope="scope"> -->
            <!-- <el-button :type="scope.row.confirmStatus==='Y'?'primary':''" size="mini" @click="confirm(scope.row)">确认</el-button> -->
            <!-- <el-button type="primary" size="mini" @click="confirm(scope.row)">确认</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="comfirmUser" label="确认人"></el-table-column> -->
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'disciplinePunish',
  data () {
    return {
      // 用户信息
      userInfo: '',
      roles: [],
      searchList: {
        year: null
      },
      data: [],
      columns: [
        {
          prop: 'year',
          label: '年份'
        },
        {
          prop: 'createUser',
          label: '上传人'
        },
        {
          prop: 'createTime',
          label: '上传时间'
        }
      ]
    }
  },
  created () {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    if (this.userInfo !== null) {
      let arr = this.userInfo.roles
      let roles = []
      if (arr != null && arr.length > 0) {
        arr.forEach(ele => {
          roles.push(ele.roleName)
        })
      }
      this.roles = roles
    }
  },
  mounted () {
    this.getDisciplinePunishList()
  },
  methods: {
    // 纪律处罚列表
    getDisciplinePunishList (message) {
      this.data = []
      this.$http.post(this.API.userComplianceDataUploadList, this.searchList).then((res) => {
        let data = res.data
        if (data.code === 200) {
          this.data = data.data
          // 处理筛选项
          if (message) {
            this.$message.success('搜索成功！')
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // year筛选纪律处罚列表
    search () {
      this.getDisciplinePunishList(true)
    },
    // 重置
    resetSearch () {
      this.searchList = {
        year: null
      }
      this.getDisciplinePunishList()
    },
    // 上传前校验
    beforeUpload (file) {
      // console.log(file)
      // file.name-文件名字
      // file.size-文件大小
      // file.type-文件类型
      // 上传前格式与大小校验
      if (this.searchList.year !== null) {
        const isExcel = file.type === 'application/vnd.ms-excel' || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        // const isLt2M = file.size / 1024 / 1024 < 2
        if (!isExcel) {
          this.$message.error('上传模板只能是Excel格式!')
        }
        // if (!isLt2M) {
        //   this.$message.error('上传模板大小不能超过 2MB!')
        // }
        // return isJPG && isLt2M
        return isExcel
      } else {
        this.$message.error('请选择年份！')
        return false
      }
    },
    // 上传
    upload (e) {
      // console.log(e)
      let formData = new FormData()
      formData.append('year', e.data.year)
      formData.append('file', e.file)
      this.$http.post(this.API.userComplianceInfoUpload, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        // console.log(res)
        if (res.status === 200) {
          let data = res.data
          if (data.code === 200) {
            this.$message.success('上传成功！')
            // 更新岗关系列表
            this.getDisciplinePunishList()
          } else {
            this.$message.error(data.msg + ' --- 请重新上传！')
            // this.$message.error('请下载模板，查看具体原因，重新上传模板！')
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 下载
    download (row) {
      this.$http.get(this.API.userComplianceInfoExport, { params: { year: row.year }, responseType: 'blob' }).then(res => {
        // console.log(res)
        if (res.status === 200) {
          // console.log(res)
          let blob = new Blob([res.data], { type: res.data.type })
          let downloadElement = document.createElement('a')
          let href = window.URL.createObjectURL(blob) // 创建下载的链接
          downloadElement.href = href
          downloadElement.download = '纪律处罚' + '-' + row.year + '.xls' // 下载后文件名
          document.body.appendChild(downloadElement) // 添加元素
          downloadElement.click() // 点击下载
          document.body.removeChild(downloadElement) // 下载完成移除元素
          window.URL.revokeObjectURL(href) // 释放掉blob对象
          this.$message.success('下载成功！')
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 附件上传
    attachmentUpload (e) {
      // console.log(e)
      let formData = new FormData()
      formData.append('relationId', e.data.relationId)
      formData.append('businessType', 'disciplinePunish')
      formData.append('file', e.file)
      this.$http.post(this.API.fileUpload, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        // console.log(res)
        if (res.status === 200) {
          let data = res.data
          if (data.code === 200) {
            this.$message.success('上传成功！')
            // 更新纪律处罚列表
            this.getDisciplinePunishList()
          } else {
            this.$message.error(data.msg + ' --- 请重新上传！')
            // this.$message.error('请下载模板，查看具体原因，重新上传模板！')
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 附件下载
    attachmentDownload (row) {
      if (row.file !== null) {
        this.$http.get(this.API.fileDownload, { params: { relationId: row.id, businessType: 'disciplinePunish' }, responseType: 'blob' }).then(res => {
          // console.log(res)
          if (res.status === 200) {
          // console.log(res)
            let blob = new Blob([res.data], { type: res.data.type })
            let downloadElement = document.createElement('a')
            let href = window.URL.createObjectURL(blob) // 创建下载的链接
            downloadElement.href = href
            downloadElement.download = row.file.fileName // 下载后文件名
            document.body.appendChild(downloadElement) // 添加元素
            downloadElement.click() // 点击下载
            document.body.removeChild(downloadElement) // 下载完成移除元素
            window.URL.revokeObjectURL(href) // 释放掉blob对象
            this.$message.success('下载成功！')
          } else {
            this.$message.error('接口调用失败！')
          }
        })
      } else {
        this.$message.error('请上传附件！')
      }
    },
    // 确认--没用到
    confirm (row) {
      if (row.file !== null) {
        this.$http.get(this.API.userComplianceDataUploadConfrim, { params: { id: row.id } }).then(res => {
          // console.log(res)
          this.$message.success('确认成功！')
          // 更新纪律处罚列表
          this.getDisciplinePunishList()
        })
      } else {
        this.$message.error('请上传附件！')
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>
